import { FC, lazy } from 'react';

const UserProfileDefaultView = lazy(() => import('./default-view/UserProfilePageDefaultView'));

export const UserProfilePage: FC = () => <UserProfileDefaultView />;
